import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import './ConfirmDialog.scss';

// A small modal yes/no question, styled with the discount form's dm-* panel
// and buttons (BrandDashboard.scss) so it reads as part of the same family.
// Portalled to <body> like the brand menu, so it is themed by html.portal-dark
// and never clipped by the shell. Escape and the backdrop cancel; focus starts
// on the safe choice.
export default function ConfirmDialog({ open, title, body, cancelLabel, confirmLabel, onCancel, onConfirm }) {
  const cancelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const prev = document.activeElement;
    cancelRef.current?.focus();
    const onKey = (e) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('keydown', onKey);
      prev?.focus?.();
    };
  }, [open, onCancel]);

  if (!open) return null;

  return createPortal(
    <div className="confirm-dialog" onMouseDown={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="dm-panel confirm-dialog__panel" role="alertdialog" aria-modal="true" aria-labelledby="confirm-dialog-title">
        <h3 className="dm-title" id="confirm-dialog-title">{title}</h3>
        {body && <p className="confirm-dialog__body">{body}</p>}
        <div className="dm-actions">
          <button type="button" className="dm-btn" ref={cancelRef} onClick={onCancel}>
            {cancelLabel}
          </button>
          <button type="button" className="dm-btn dm-btn--primary" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
